import React, { useState, useEffect } from 'react';
import Slider from '../lib/slider';
import Info from '../lib/info';
import Confirm from '../lib/confirm';
import { UserFields, Countries } from '../lib/constants';

const Profil = props => {
  const [user, setUser] = useState({});
  const [rgAddr, setRgAddr] = useState(false);
  const [infoMsg, setInfoMsg] = useState(false);
  const [flatMsg, setFlatMsg] = useState({});

  const { dataprovider, staticel, userinfo, setUserField, is_dev } = props;

  useEffect(() => {
    if (Object.keys(user).length === 0) return;
    if (user.id) {
      for (var i=0;i<UserFields.length;i++) {
        if (user['r_'+UserFields[i][0]]) {
          setRgAddr(true);
        }
      }
    }
  }, [user]);
  
  useEffect(() => {
    if (userinfo===false) return;
    if (userinfo.id) {
      dataprovider.getRow('user', userinfo.id, '', setUser);
    }
    else {
      setUser({id:0});
    }
  }, [dataprovider, userinfo]);

  
  const toggleRgAddr = (ev) => {
    if (rgAddr) {
      const us = {...user};
      for (var i=0;i<UserFields.length;i++) {
        us['r_'+UserFields[i][0]] = '';
      }
      setUser(us);
    }
    setRgAddr(!rgAddr);
  }
  
  const closeInfoMsg = () => {
    setInfoMsg(false);
    window.location.reload();
  }
  
  const handleUserChange = (key) => (ev) => {
    setUser({...user, [key]:ev.target.value});
  }
  const doEmailChange = () => {
    setFlatMsg({});
    handleSave('mail');
  }
  const checkFlat = (data) => {
    console.log(data);
    if (!data.current && data.new>0) {
      setFlatMsg({msg:'Für diese E-Mail gibt es eine Pauschallizenz. Sie wird automatisch aktiviert.', setMsg: setFlatMsg, 
        buttons:[{text:'Abbrechen'},{typ:'primary',text:'Ausführen', action:doEmailChange}]});  
    }
    else if (data.current && !data.new) {
      setFlatMsg({msg:'Du hast zur Zeit eine Pauschallizenz. Mit dem Ändern der E-Mail verlierst du diese.', setMsg: setFlatMsg, 
        buttons:[{text:'Abbrechen'},{typ:'primary',text:'Ausführen', action:doEmailChange}]});
    }
    else if (!data.valid) {
      setFlatMsg({msg:'Ungültige E-Mail.', setMsg: setFlatMsg, buttons:[{text:'Schliessen'}]});
    }
    else if (data.taken) {
      setFlatMsg({msg:'Es ist bereits ein Konto mit dieser E-Mail registriert.', setMsg: setFlatMsg, buttons:[{text:'Schliessen'}]});
    }
    else {
      console.log('handleSave')
      handleSave('mail');
    }
  }
  const handleEmailChange = (ev) => {
    const email = ev.target.value;
    dataprovider.update('user/checkflatemail', { id:user.id, email: user.email }, checkFlat);
  }
  const doneUserSet = (res) => {
    if (res.id) {
      const us = {...user, id:res.id};
      setUser(us);
      setUserField('id', res.id);
    }
    if (res.msg) {
      setInfoMsg([res.msg]);
    }
  }
  const handleSave = (type) => {
    const data = {...user, rgaddr:rgAddr, profil:type};
    dataprovider.update('user/'+userinfo.id, data, doneUserSet);
  }
  
  if (!user['id']) {
    return (
      <>
        <Slider staticel={staticel} page={2} is_dev={is_dev} />
        <div className="container pt-5 mt-5">
          <div className="row align-items-top">
            <div className="col-lg-6 pe-4">
              <h4>Bitte erst anmelden oder registrieren.</h4>
            </div>
          </div>
        </div>
      </>
    )
  }

  var validEmail = true;
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!user.email || !re.test(String(user.email).toLowerCase())) {
    validEmail = false;
  }

  var validPW = true;
  const re2 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/
  if (user.password && !re2.test(String(user.password))) {
    validPW = false;
  }
  var validPW2 = true;
  if (user.password!==user.password_rep) {
    validPW2 = false;
  }  
  
  var isValid = true;
  const inValid = {};
  for (var i=0;i<UserFields.length;i++) {
    var f = UserFields[i][0];          
    if (f==='country' && !user[f]) user[f] = 'CH';
    if (f==='zip' && (user[f].length<4 || user[f].length>5)) {
      inValid[f] = true;
      isValid = false;
    }
    if (i>0 && !user[f]) {
      inValid[f] = true;
      isValid = false;
    }
    if (rgAddr && f==='zip' && (user['r_'+f].length<4 || user['r_'+f].length>5)) {
      inValid['r_'+f] = true;
      isValid = false;
    }
    if (rgAddr && i>0 && !user['r_'+f]) {
      if (f==='country' && !user['r_'+f]) user['r_'+f] = 'CH';
      inValid['r_'+f] = true;
      isValid = false;
    }
  }

  console.log(props)
  
  return (
    <>
      <Slider staticel={staticel} page={2} is_dev={is_dev} />
      <div className="container pt-5 mt-5">
        <div className="row align-items-top">
          <div className="col-lg-9 pe-4">
            <h2>Profil bearbeiten</h2>
           <>
            <div className="row align-items-center">
              <div className="col-3 text-end"></div>
              <div className="col-9"><h6>Zugangsdaten</h6></div>
            </div>
            <div className="row mb-2 align-items-center">
              <div className="col-3 text-end">E-Mail</div>
              <div className="col-6">
                <input type="email" value={user.email} onChange={handleUserChange('email')} className={"form-control"+(!validEmail?" is-invalid":"")} />
              </div>
              <div className="col-12 col-lg-3 text-center">
                <button type="button" className={"btn btn-"+(validEmail && user.email !== props.userinfo.email?"primary":"secondary")}  disabled={!validEmail || user.email === props.userinfo.email} onClick={handleEmailChange}>E-Mail ändern</button>
              </div>
            </div>
            <div className="row mb-2 align-items-center">
              <div className="col-3 text-end">Neues Passwort</div>
              <div className="col-6">
                <input type="text" value={user.password} onChange={handleUserChange('password')} className={"form-control"+(!validPW?" is-invalid":"")} />
                <div className="invalid-feedback">Min. 8 Zeichen, muss Gross- und Kleinbuchstaben sowie Zahlen enthalten.</div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-3 text-end">Passwort wiederholen</div>
              <div className="col-6">
                <input type="text" value={user.password_rep} onChange={handleUserChange('password_rep')} className={"form-control"+(!validPW2?" is-invalid":"")} />
              </div>
              <div className="col-12 col-lg-3 text-center">
                <button type="button" className={"btn btn-"+(user.password && validPW && validPW2?"primary":"secondary")}  disabled={!validPW || !validPW2 || !user.password} onClick={() => handleSave('pw')}>Passwort setzen</button>
              </div>
            </div>
           </> 
            <div className="row mt-4 align-items-center">
              <div className="col-3 text-end"></div>
              <div className="col-9"><h6>{rgAddr?"Zustelladresse":"Rechnungs- und Zustelladresse"}</h6></div>
            </div>
        <>
        {UserFields.map((el, k) => (
            <div className="row mb-2 align-items-center" key={el[0]}>
              <div className="col-3 text-end">{el[1]}</div>
          {el[0]==='country'?
              <div className="col-9">
                <select value={user[el[0]]} onChange={handleUserChange(el[0])} className="form-select">
            {Countries.map(c=>(
                  <option value={c.value}>{c.text}</option>
            ))}
                </select>
              </div>
          :
              <div className="col-9">
                <input value={user[el[0]]} onChange={handleUserChange(el[0])} maxlength="35" className={"form-control"+(inValid[el[0]]?" is-invalid":"")} />
              </div>
          }
            </div>
        ))}
        </>
        
            <div className="row mb-2 mt-4 align-items-center">
              <div className="col-3 text-end"></div>
              <div className="col-9">
                <input className="form-check-input" type="checkbox" checked={rgAddr} onChange={toggleRgAddr} /> Abweichende Rechnungsadresse
              </div>
            </div>
        {rgAddr && UserFields.map((el, k) => (
            <div className="row mb-2 align-items-center" key={el[0]}>
              <div className="col-3 text-end">{el[1]}</div>
              <div className="col-9">
                <input value={user['r_'+el[0]]} onChange={handleUserChange('r_'+el[0])} className={"form-control"+(inValid['r_'+el[0]]?" is-invalid":"")} />
              </div>
            </div>
        ))}
            <div className="row mb-2 align-items-center">
              <div className="col-3 text-end"></div>
              <div className="col-9">
                <button type="button" className={"btn btn-"+(isValid?"primary":"secondary")+" mt-4"}  disabled={!isValid} onClick={() => handleSave('user')}>Adresse speichern</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Info msg={infoMsg} setMsg={closeInfoMsg} />
      <Confirm msg={flatMsg.msg} setMsg={setFlatMsg} buttons={flatMsg.buttons} />
    </>
  )
}

export default Profil;
